// extracted by mini-css-extract-plugin
module.exports = {"checkboxSpan":"Checkbox_checkboxSpan__4VZ07","disabled":"Checkbox_disabled__1k8kt"};